import RenewalOLdSchool from "./RenewalOldSchool"

export default  RenewalOLdSchool;
